import React from "react";
import { Mail, Phone, MessageSquare } from "lucide-react";

export const Contacto: React.FC = () => {
  return (
    <div className="max-w-4xl mx-auto space-y-8 animate-fade-in">
      <header>
        <h1 className="text-3xl font-bold text-gray-900 tracking-tight">Contacto EMDECOB</h1>
        <p className="text-gray-500 mt-1">Soporte técnico y atención al usuario</p>
      </header>

      <div className="grid md:grid-cols-2 gap-8">
        <div className="bg-white p-8 rounded-3xl border border-gray-100 shadow-sm space-y-6">
          <h2 className="text-xl font-bold text-gray-900">Canales de Atención</h2>
          
          <div className="flex items-start gap-4">
            <div className="w-10 h-10 rounded-lg bg-red-50 flex items-center justify-center text-[#80142D] shrink-0">
              <Phone size={20} />
            </div>
            <div>
              <p className="font-semibold text-gray-900">Soporte Tecnico</p>
              <p className="text-gray-500">314 247 2622</p>
            </div>
          </div>

          <div className="flex items-start gap-4">
            <div className="w-10 h-10 rounded-lg bg-blue-50 flex items-center justify-center text-blue-600 shrink-0">
              <Mail size={20} />
            </div>
            <div>
              <p className="font-semibold text-gray-900">Correo Electrónico</p>
              <a 
                href="mailto:direccionanalitica@emdecob.com" 
                className="text-blue-600 hover:underline transition-all font-medium"
              >
                direccionanalitica@emdecob.com
              </a>
            </div>
          </div>
        </div>

        <div className="bg-[#80142D] p-8 rounded-3xl text-white flex flex-col justify-center shadow-xl">
          <h2 className="text-2xl font-bold mb-4">¿Necesita ayuda?</h2>
          <p className="text-red-50 mb-6">
            Nuestro equipo de analistas y desarrolladores está disponible para ayudarle con cualquier duda técnica o requerimiento de información.
          </p>
          <div className="w-20 h-1 bg-white/30 rounded-full" />
        </div>
      </div>
    </div>
  );
};

export default Contacto;
